
import React, { useState, useEffect } from 'react';
import { Image, Offcanvas } from 'react-bootstrap';
import configData from "../../config.json";
import { useParams, useLocation } from 'react-router-dom';



const EstLayout = () => {
    const { id } = useParams();
    const [data, setData] = useState([]);
    const [properties, setProperties] = useState([]);
    const [isLoading, setIsLoading] = useState(false)


    const [svgPaths, setSvgPaths] = useState([]);

    const [svgData, setSvgData] = useState({
        svgPaths: [],
        svgImg: '',
        width: 0,
        height: 0
    });

    useEffect(() => {
        setIsLoading(true);
      
        const fetchData = async () => {
          try {
            const response = await fetch(`${configData.SERVER_URL}/estate/get-layout/${id}`);
            if (!response.ok) {
                const message = JSON.stringify({ action: 'Error', id });
                window.ReactNativeWebView.postMessage(message);
                setIsLoading(false);
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
      
            if (!data || !data.data || !data.data.svgPaths) {
                const message = JSON.stringify({ action: 'Error data', id });
                window.ReactNativeWebView.postMessage(message);
                setIsLoading(false);
              throw new Error("svgPaths is undefined in the response data");
            }
      
            setSvgData({
              svgPaths: data.data.svgPaths,
              svgImg: data.data.svgImg,
              width: data.data.width,
              height: data.data.height
            });
            setSvgPaths(data.data.svgPaths);
            setIsLoading(false);
          } catch (error) {
            const message = JSON.stringify({ action: 'Error', error });
            window.ReactNativeWebView.postMessage(message);
            setIsLoading(false);
            console.error('Error fetching SVG paths:', error);
          }
        };
      
        fetchData();
      }, [id]);
      

    const getEstPlots = async () => {

        try {
            return fetch(`${configData.SERVER_URL}/plot/estate/plots/${id}`, {
                method: "get",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    // "x-auth-token":  window.localStorage.getItem("token")
                },
            })
                .then((response) => response.json())
                .then((responseJson) => {
                    console.log("Data ", responseJson.data, null, 2)
                    const message = JSON.stringify({ action: 'This is after the fetch', id });
                    setProperties(responseJson.data);
                })
                .catch((error) => {
                    console.error(error);
                });

        } catch (error) {
            console.log(error);
        }

    }

    useEffect(() => {
        getEstPlots()
    }, [])

    properties.forEach((property) => {
        const element = document.getElementById(`${property.plotIdentifier}`);
        if (element) {
            if (property.status === 'sold') {
                element.style.fill = 'rgb(255, 0, 0, 0.4)';
            }
            if (property.status === 'reserved') {
                element.style.fill = 'rgb(255, 210, 0, 0.4)';
            }
        }

    })


    useEffect(() => {
        if (svgData?.svgImg) {
            const imageUrl = `${configData.PIC_URL}/${svgData.svgImg}`;
            console.log("Image URL:", imageUrl);

            document.documentElement.style.setProperty('--background-img', `url('${imageUrl}')`);
            document.documentElement.style.setProperty('--layout-width', `${svgData.width || '100%'}px`);
            document.documentElement.style.setProperty('--layout-height', `${svgData.height || '100%'}px`);
        }
    }, [svgData]);

    return (
        <>

            {/* {`${configData.PIC_URL}/${e.image}`} */}
            {/* <p>{`${configData.PIC_URL}/${svgData?.svgImg}`}</p> */}
            <div className="layout">
                {isLoading ? <>

                    <div className="col-md-12 d-flex justify-content-center pt-5 pb-5">
                        <div class="spinner-border" role="status">
                        </div>
                    </div>

                </> :
                    <svg width={svgData.width}
                        height={svgData.height}
                        viewBox={`0 0 ${svgData.width} ${svgData.height}`}
                        fill="none" xmlns="http://www.w3.org/2000/svg">

                        <g id="Group 2">
                            {svgPaths && svgPaths.map((path) => (<>
                                <path
                                    key={path.id}
                                    fill='rgba(255, 255, 255, 0.2)'
                                    id={path.id}
                                    d={path.d}
                                    stroke="black"
                                />
                            </>))}
                        </g>

                    </svg>
                }


            </div>



        </>
    );
};


export default EstLayout;

